import { t as e } from "../../utils-C1uyTI6x.js";
import { t } from "../../constants-B7fXbm2f.js";
import { t as n } from "../../_plugin-vue_export-helper-B52Kst-M.js";
import { createElementBlock as r, createElementVNode as i, normalizeClass as a, openBlock as o } from "vue";
//#region ../src/icons/gamepad.vue
var s = {
	name: "DtIconGamepad",
	props: {
		size: {
			type: String,
			default: "500",
			validator: (e) => Object.keys(t).includes(e)
		},
		ariaLabel: {
			type: String,
			default: void 0
		}
	},
	emits: ["loaded"],
	computed: {
		iconSizeClass() {
			return t[this.size];
		},
		ariaHidden() {
			return this.ariaLabel ? "false" : "true";
		},
		dataQA() {
			return this.$attrs["data-qa"] ?? "dt-icon";
		}
	},
	created() {
		this.$emit("loaded"), this.uniqueID = e();
	}
}, c = [
	"aria-label",
	"data-qa",
	"aria-hidden"
], l = ["clip-path"], u = ["id"];
function d(e, t, n, s, d, f) {
	return o(), r("svg", {
		"aria-label": n.ariaLabel,
		class: a([f.iconSizeClass, "d-icon d-icon--gamepad"]),
		"data-qa": f.dataQA,
		"aria-hidden": f.ariaHidden,
		role: "img",
		"data-name": "Gamepad",
		xmlns: "http://www.w3.org/2000/svg",
		viewBox: "0 0 12 12"
	}, [i("g", {
		"clip-path": `url(#${e.uniqueID}a)`,
		fill: "currentColor",
		"fill-rule": "evenodd",
		"clip-rule": "evenodd"
	}, [...t[0] || (t[0] = [i("path", { d: "M4 4a.5.5 0 0 1 .5.5V5H5a.5.5 0 1 1 0 1h-.5v.5a.5.5 0 1 1-1 0V6H3a.5.5 0 0 1 0-1h.5v-.5A.5.5 0 0 1 4 4Zm4.5 1a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H9a.5.5 0 0 1-.5-.5ZM7 6a.5.5 0 0 1 .5-.5h.005a.5.5 0 1 1 0 1H7.5A.5.5 0 0 1 7 6Z" }, null, -1), i("path", { d: "M7.043 8.499A.505.505 0 0 1 7 8.5H4.914a.5.5 0 0 0-.353.147l-.72.72c-.255.255-.633.633-1.34.633a2 2 0 0 1-2-2c0-.809.306-3.362.345-3.686l.001-.01a.404.404 0 0 0 .003-.022l.004-.041a2.5 2.5 0 0 1 2.486-2.24H8.5c.027 0 .054.002.08.006A.504.504 0 0 1 8.66 2a2.5 2.5 0 0 1 2.49 2.283l.003.019.001.01v.002c.04.327.346 2.877.346 3.686a2 2 0 0 1-2 2c-.707 0-1.085-.378-1.34-.633l-.72-.72a.5.5 0 0 0-.354-.147h-.043ZM8.58 2.994A.503.503 0 0 1 8.5 3H3.34a1.5 1.5 0 0 0-1.49 1.347l-.001.006v.002a3.71 3.71 0 0 1-.01.079C1.796 4.803 1.5 7.269 1.5 8a1 1 0 0 0 1 1c.28 0 .402-.108.647-.353l.707-.707a1.5 1.5 0 0 1 1.06-.44H7l.043.002a1.5 1.5 0 0 1 1.104.438l.707.707c.245.245.366.353.646.353a1 1 0 0 0 1-1c0-.73-.293-3.193-.338-3.565a1.664 1.664 0 0 1-.006-.05l-.003-.03-.001-.008A1.5 1.5 0 0 0 8.66 3a.504.504 0 0 1-.08-.006Z" }, null, -1)])], 8, l), i("defs", null, [i("clipPath", { id: `${e.uniqueID}a` }, [...t[1] || (t[1] = [i("path", {
		fill: "#fff",
		d: "M0 0h12v12H0z"
	}, null, -1)])], 8, u)])], 10, c);
}
var f = /* @__PURE__ */ n(s, [["render", d]]);
//#endregion
export { f as default };

//# sourceMappingURL=gamepad.js.map